import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import { decodeData } from '../../Constants/constants';
import { currentDateAndTime } from '../../Constants/constants';
class LeaveTypeSandBox extends Component {

    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            leave_type_id: 0,
            leave_category_id: 0,
            yearly_limit: "",
            leave_type_name: "",
            leave_type_name_code: "",
            leave_per_instance_min: "",
            leave_per_instance_max: "",
            effective_date: "",
            leave_gender: "Both",
            paid_leave: 0,
            past_date: 0,
            future_date: 1,
            future_days: 360,
            past_days: 0,
            leave_encashment: 0,
            half_day: 1,
            required_document: 0,
            leave_sandwich: 0,
            leave_hide: "0",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            leave_category_rows: [],
            errors: {},
            data: [],
            decodedData: [],
            date:'',
            
        };
        this.handleRememberMeChange = this.handleRememberMeChange.bind(this);
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetLeaveCategories();
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    // GetInfo = () => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Masters/GetLeaveTypeInfo?leave_type_id=${this.state.leave_type_id}`, { headers }).then((response) => {
    //         const { data, success } = response.data;
    //         if (success === true) {
    //             this.setState(
    //                 {
    //                     leave_category_id: data[0].leave_category_id,
    //                     leave_type_name: data[0].leave_type_name,
    //                     leave_gender: data[0].leave_gender,
    //                     paid_leave: data[0].paid_leave,
    //                     required_document: data[0].required_document,
    //                     half_day: data[0].half_day,
    //                     past_date: data[0].past_date,
    //                     past_days: data[0].past_days,
    //                     future_date: data[0].future_date,
    //                     future_days: data[0].future_days,
    //                     leave_encashment: data[0].leave_encashment,
    //                     leave_per_instance_min: data[0].leave_per_instance_min,
    //                     leave_per_instance_max: data[0].leave_per_instance_max,
    //                     effective_date: data[0].effective_date,
    //                     leave_sandwich: data[0].leave_sandwich,
    //                     leave_hide: data[0].leave_hide,
    //                     yearly_limit: data[0].total_leave_balance,
    //                     data: data[0],

    //                 }
    //             )
    //         }
    //     });
    // }
    GetInfo = (row) => {
        console.log(row);
        // const { apiURL, apiHeaderJSON } = this.context;
        // const headers = apiHeaderJSON;
        // axios.get(`${apiURL}Masters/GetLeaveTypeInfoSandBox?leave_type_id=${this.state.leave_type_id}`, { headers }).then((response) => {
        //     const { data, success } = response.data;
        //     if (success === true) {
        //         this.setState(
        //             {
        //                 // leave_category_id: data[0].leave_category_id,
        //                 leave_type_name: data[0].leave_type_name,
        //                 leave_type_name_code: data[0].leave_type_code,
        //                 leave_gender: data[0].gender,
        //                 // paid_leave: data[0].paid_leave,
        //                 // required_document: data[0].required_document,
        //                 // half_day: data[0].half_day,
        //                 // past_date: data[0].past_date,
        //                 // past_days: data[0].past_days,
        //                 // future_date: data[0].future_date,
        //                 // future_days: data[0].future_days,
        //                 // leave_encashment: data[0].leave_encashment,
        //                 // leave_per_instance_min: data[0].leave_per_instance_min,
        //                 // leave_per_instance_max: data[0].leave_per_instance_max,
        //                 // effective_date: data[0].effective_date,
        //                 // leave_sandwich: data[0].leave_sandwich,
        //                 // leave_hide: data[0].leave_hide,
        //                 yearly_limit: data[0].total_leave_balance,
        //                 data: data[0],

        //             }
        //         )
        //     }
        // });
        this.setState(
            {
                // leave_category_id: data[0].leave_category_id,
                leave_type_name: row?.leave_type_name,
                leave_type_name_code: row?.leave_type_code,
                leave_gender: row?.gender,
                // paid_leave: row?.paid_leave,
                // required_document: row?.required_document,
                // half_day: row?.half_day,
                // past_date: row?.past_date,
                // past_days: row?.past_days,
                // future_date: row?.future_date,
                // future_days: row?.future_days,
                // leave_encashment: row?.leave_encashment,
                // leave_per_instance_min: row?.leave_per_instance_min,
                // leave_per_instance_max: row?.leave_per_instance_max,
                // effective_date: row?.effective_date,
                // leave_sandwich: row?.leave_sandwich,
                leave_hide: row?.leave_hide,
                yearly_limit: row?.total_leave_balance,
                errors:{
                    ...this.state.errors,
                    leave_type_name:'',
                    leave_type_name_code:'',
                    yearly_limit:'',

                }
            }
        )

    }
    GetLeaveCategories = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetLeaveCategories`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        leave_category_rows: data.data.map((row) => ({
                            value: row.leave_category_id,
                            label: row.leave_name
                        }))
                    }));
                }
            });
    }
    // GetList = () => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Masters/GetLeaveTypes`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
    //         var data = response.data;
    //         if (response.data.success === true) {
    //             this.setState({
    //                 rows: data.data,
    //                 next: data.next,
    //                 prev: data.prev,
    //                 page: data.page,
    //                 total_records: data.total_records,
    //                 total_pages: data.total_pages,
    //                 loadingList: false
    //             });
    //         } else {
    //             this.setState({ loadingList: false });
    //         }
    //     });
    // }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetLeaveTypesSandbox`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }


    // handleSubmit = (e) => {
    //     e.preventDefault();
    //     const errors = this.validateForm();
    //     if (Object.keys(errors).length > 0) {
    //         this.setState({ errors });
    //         return;
    //     }
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     var formData = {
    //         leave_category_id: this.state.leave_category_id,
    //         leave_type_name: this.state.leave_type_name,
    //         leave_gender: this.state.leave_gender,
    //         paid_leave: this.state.paid_leave,
    //         half_day: this.state.half_day,
    //         past_date: this.state.past_date,
    //         past_days: this.state.past_days,
    //         future_date: this.state.future_date,
    //         future_days: this.state.future_days,
    //         required_document: this.state.required_document,
    //         leave_per_instance_min: this.state.leave_per_instance_min,
    //         leave_per_instance_max: this.state.leave_per_instance_max,
    //         effective_date: this.state.effective_date,
    //         leave_encashment: this.state.leave_encashment,
    //         leave_sandwich: this.state.leave_sandwich,
    //         leave_hide: this.state.leave_hide,
    //         yearly_limit: this.state.yearly_limit,
    //     }
    //     if (this.state.leave_type_id !== 0) {
    //         formData.leave_type_id = this.state.leave_type_id;
    //     }



    //     axios.post(`${apiURL}Masters/CreateLeaveType`, formData, { headers }).then((response) => {
    //         const { success } = response.data;

    //         if (success === true) {
    //             this.resetForm();

    //             this.setState({ loadingList: true }, (prevState) => {
    //                 this.GetList();
    //             })
    //             Swal.fire({
    //                 title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
    //                 text: response.data.message,
    //                 icon: response.data.success === true ? 'success' : 'error',
    //                 timer: 2000,
    //                 timerProgressBar: true,
    //                 showConfirmButton: false,
    //             })
    //         } else {
    //             Swal.fire({
    //                 title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
    //                 text: response.data.message,
    //                 icon: response.data.success === true ? 'success' : 'error',
    //                 timer: 2000,
    //                 timerProgressBar: true,
    //                 showConfirmButton: false,
    //             })
    //             this.setState({ loadingList: true }, (prevState) => {
    //                 this.GetList();
    //             })
    //         }

    //     })
    // };
    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            leave_category_id: this.state.leave_category_id,
            leave_type_name: this.state.leave_type_name,
            leave_type_code: this.state.leave_type_name_code,
            leave_gender: this.state.leave_gender,
            paid_leave: this.state.paid_leave,
            half_day: this.state.half_day,
            past_date: this.state.past_date,
            past_days: this.state.past_days,
            future_date: this.state.future_date,
            future_days: this.state.future_days,
            required_document: this.state.required_document,
            leave_per_instance_min: this.state.leave_per_instance_min,
            leave_per_instance_max: this.state.leave_per_instance_max,
            effective_date: this.state.effective_date,
            leave_encashment: this.state.leave_encashment,
            leave_sandwich: this.state.leave_sandwich,
            leave_hide: this.state.leave_hide,
            yearly_limit: this.state.yearly_limit,
            date: currentDateAndTime(),
        }
        // console.log("date===>",date);
        if (this.state.leave_type_id !== 0) {
            formData.leave_type_id = this.state.leave_type_id;
        }



        axios.post(`${apiURL}Masters/CreateLeavetypeSandbox`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();

                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            }

        }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(this.setState({postLoading:false}));
    };

    resetForm = () => {
        this.setState({
            leave_type_id: 0,
            leave_category_id: 0,
            leave_type_name: "",
            leave_type_name_code: "",
            yearly_limit:"",
            leave_per_instance_min: "",
            leave_per_instance_max: "",
            effective_date: "",
            leave_gender: "Both",
            paid_leave: 0,
            leave_sandwich: 0,
            half_day: 1,
            past_date: 0,
            future_date: 1,
            future_days: 360,
            past_days: 0,
            leave_hide: "0",
            leave_encashment: 0,
            required_document: 0,
        });
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    leave_type_id: id,
                    date: currentDateAndTime(),
                };
                axios
                    .post(`${apiURL}Masters/DeleteLeaveTypeSandBox`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            text: 'Opps...! Something went wrong.',
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false,
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleRememberMeChange(event) {
        const value = event.target.checked ? 1 : 0;
        this.setState({
            required_document: value
        });
    }
    validateForm = () => {
        const errors = {};

        if (!this.state.leave_type_name) {
            errors.leave_type_name = 'Leave type name is required';
        }
        if (!this.state.leave_type_name_code) {
            errors.leave_type_name_code = 'Leave Type code is required';
        }
        // if (this.state.leave_category_id === 0) {
        //     errors.leave_category_id = 'Select leave category is required';
        // }
        if (this.state.yearly_limit === '') {
            errors.yearly_limit = 'Yearly Limit is required';
        }

        return errors;
    };

    render() {
        const { errors } = this.state;
        const genderOptions = [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' },
            { value: 'Both', label: 'Both' },
        ]
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Leave Type`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Leave Type</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                {/* <form onSubmit={this.handleSubmit} className="row"> */}
                                                <form className="row">
                                                    {/* <div className="col-md-12 mt-3 mb-3">
                                                        <label>Select Leave Category</label>
                                                        <Select onChange={(selectedOption) => this.handleSelectChange('leave_category_id', selectedOption)} placeholder={`Select Leave Category`} options={this.state.leave_category_rows} value={this.state.leave_category_rows.find(option => option.value === this.state.leave_category_id)} />
                                                        {errors.leave_category_id && <div className="text-danger">{errors.leave_category_id}</div>}
                                                    </div> */}
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="leave_type_name" className="form-label">Leave Type Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.leave_type_name ? 'is-invalid' : ''}`}
                                                            id="leave_type_name"
                                                            name="leave_type_name"
                                                            value={this.state.leave_type_name}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Leave Type Name"
                                                        />
                                                        {errors.leave_type_name && <div className="text-danger">{errors.leave_type_name}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="leave_type_name" className="form-label">Leave Type Code</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.leave_type_name_code ? 'is-invalid' : ''}`}
                                                            id="leave_type_name_code"
                                                            name="leave_type_name_code"
                                                            value={this.state.leave_type_name_code}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Leave Type Code"
                                                        />
                                                        {errors.leave_type_name_code && <div className="text-danger">{errors.leave_type_name_code}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="leave_gender" className="form-label">Select Gender:</label>
                                                        <Select
                                                            id="leave_gender"
                                                            name="leave_gender"
                                                            value={genderOptions.find(option => option.value === this.state.leave_gender)}
                                                            isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={(selectedOption) => this.handleSelectChange('leave_gender', selectedOption)}
                                                            options={genderOptions}
                                                            placeholder="Select Leave Gender"
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="yearly_limit" className="form-label">Yearly Limit</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.yearly_limit ? 'is-invalid' : ''}`}
                                                            id="yearly_limit"
                                                            name="yearly_limit"
                                                            value={this.state.yearly_limit}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Yearly Limit"
                                                        />
                                                        {errors.yearly_limit && <div className="invalid-feedback">{errors.yearly_limit}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <div>
                                                            <label htmlFor="half_day" className="form-label">Leave Hide :</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2" >
                                                            <input
                                                                type="radio"
                                                                id="leave_hide1"
                                                                name="leave_hide"
                                                                value="1"
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                checked={this.state.leave_hide == '1'}
                                                                onChange={() => this.handleRadioChange('leave_hide', '1')}
                                                                className={`form-check-input ${errors.half_day ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="leave_hide1" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="leave_hide0"
                                                                name="leave_hide"
                                                                value="0"
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                checked={this.state.leave_hide == '0'}
                                                                onChange={() => this.handleRadioChange('leave_hide', '0')}
                                                                className={`form-check-input ${errors.half_day ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="leave_hide0" className="form-check-label">No</label>
                                                        </div>
                                                    </div>
                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.leave_type_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.leave_type_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.leave_type_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)
                                                        }
                                                        {/* <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} /> */}
                                                        {/* <button onClick={this.handleSubmit} className='btn btn-primary btn-label waves-effect right waves-light float-right' >Save</button> */}

                                                        {
                                                            this.state.leave_type_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />New</button> : <div></div>
                                                        }
                                                    </div>)}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>

                                                    {/* <th>Leave Category</th> */}
                                                    <th>Leave Type Name</th>
                                                    <th>Leave Type Code</th>
                                                    {/* <th>Leave Instance Min</th> */}
                                                    {/* <th>Leave Instance Max</th> */}
                                                    <th>Leave Gender </th>
                                                    <th>Yearly Limit </th>
                                                    {/* <th>Effective Date</th> */}
                                                    {/* <th>Paid Leave </th>
                                                    <th>Leave Encashment</th>
                                                    <th>Past Date </th>
                                                    <th>Half Day Applicable </th>
                                                    <th>Attachment </th> */}
                                                      { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={150} className=' text-center'>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.leave_type_id}>
                                                            {/* <td>{row.leave_category_label[0].concatenated_data}</td> */}
                                                            <td>{row?.leave_type_name}</td>
                                                            <td>{row?.leave_type_code}</td>
                                                            {/* <td>{row.leave_per_instance_min}</td> */}
                                                            {/* <td>{row.leave_per_instance_max}</td> */}
                                                            <td>{row?.gender}</td>
                                                            <td>{row?.total_leave_balance}</td>
                                                            {/* <td>{formatDate(row.effective_date)}</td> */}
                                                            {/* <td>{row.paid_leave_label}</td>
                                                            <td>{row.leave_encashment_label}</td>
                                                            <td>{row.past_date_label}</td>
                                                            <td>{row.half_day_label}</td>
                                                            <td>{row.required_document_label}</td> */}
                                                            { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (   
                                                                <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(1) && (
                                                                <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button>)}
                                                                { this.state.decodedData?.includes(3) && (
                                                                <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={11} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                                <div id="myModal" className="modal fade" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true" style={{ display: 'none' }}>
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="myModalLabel">Leave Details</h5>
                                                <button type="button" onClick={() => this.resetForm()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="card shadow-none">
                                                    <div className="card-body">

                                                        <div className="table-responsive">
                                                            <table className="table table-borderless mb-0">
                                                                <tbody>
                                                                    {/* <tr>
                                                                        <th className="ps-0" scope="row">Leave Category :</th>
                                                                        <td className="text-muted">{this.state.leave_category_rows.find(option => option.value === this.state.leave_category_id) ? this.state.leave_category_rows.find(option => option.value === this.state.leave_category_id).label : ''}</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Leave Type Name :</th>
                                                                        <td className="text-muted">{this.state.leave_type_name}</td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <th className="ps-0" scope="row">Leave Instance Min :</th>
                                                                        <td className="text-muted">{this.state.leave_per_instance_min}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Leave Instance Max :</th>
                                                                        <td className="text-muted">{this.state.leave_per_instance_max}</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Leave Gender :</th>
                                                                        <td className="text-muted">{this.state.leave_gender}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Yearlt Limit :</th>
                                                                        <td className="text-muted">{this.state.yearly_limit}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Hide Leave :</th>
                                                                        <td className="text-muted">{this.state.leave_hide == "0"? "No":"Yes"}</td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <th className="ps-0" scope="row">Effective Date :</th>
                                                                        <td className="text-muted">{formatDate(data.effective_date)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Paid Leave :</th>
                                                                        <td className="text-muted">{data.paid_leave_label}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Leave Encashment :</th>
                                                                        <td className="text-muted">{data.leave_encashment_label}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Half Day Applicable :</th>
                                                                        <td className="text-muted">{data.half_day_label}</td>
                                                                    </tr> */}
                                                                    {/* <tr>
                                                                        <th className="ps-0" scope="row">Sandwich Leave :</th>
                                                                        <td className="text-muted">{data.leave_sandwich_label}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Past Date:</th>
                                                                        <td className="text-muted">{data.past_days} Days</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Future Date:</th>
                                                                        <td className="text-muted">{data.future_days} Days</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Attachment :</th>
                                                                        <td className="text-muted">{data.required_document_label}</td>
                                                                    </tr> */}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="modal-footer">
                                                <button style={{ float: 'right' }} type="button" data-bs-dismiss="modal" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-left-line label-icon align-middle fs-16 ms-2`} />Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(LeaveTypeSandBox);